export enum LocalStorageKeys {
  CONNECTED_TO_WALLET_ONCE = "CONNECTED_TO_WALLET_ONCE",
}

export enum SessionStorageKeys {
  AUTH_ACCESS_TOKEN = "AUTH_ACCESS_TOKEN",
}

export const storage = {
  write: (key: LocalStorageKeys, data: any) => {
    localStorage[key] = JSON.stringify(data);
  },
  delete: (key: LocalStorageKeys) => {
    localStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
  },
  read: (key: LocalStorageKeys, ifDoesntExist?: any) => {
    try {
      return JSON.parse(localStorage[key]);
    } catch (error) {
      if (ifDoesntExist) {
        localStorage[key] = JSON.stringify(ifDoesntExist);
        return ifDoesntExist;
      }
      return null;
    }
  },
  sessionStorage: {
    write: (key: SessionStorageKeys, data: any) => {
      sessionStorage[key] = JSON.stringify(data);
    },
    read: (key: SessionStorageKeys) => {
      try {
        return JSON.parse(sessionStorage[key]);
      } catch (error) {
        return null;
      }
    },
  },
};
